/**
 * Input component
 *
 * Optional props:
 * inlineBlock : boolean - display inline-block
 * width : string - width of button (with unit)
 * auto : boolean - auto width
 * noBorder : boolean - disable border
 * success : boolean - success look
 * warning : boolean - warning look
 * error : boolean - error look
 *
 * Examples of component:
 * <Input width="100px" placeholder="Standard input" />
 * <Input error placeholder="Error style" />
 *
 */

import styled from 'styled-components';
import { colors } from '../../variables';
import { InputMessage } from '../';
import React from 'react';
import approveIcon from '../../../images/approve.svg';
import errorIcon from '../../../images/error.svg';

const getWidth = props => {
	if (props.width) return props.width;
	if (props.auto) return 'auto';
	return '100%';
};

const getBorderColor = (props, state = false) => {
	if (props.success) return colors.green.eco;
	if (props.warning) return colors.orange.spreader;
	if (props.error) return colors.red.warning;
	if (state === 'focus') return colors.blue.brommaLight;

	return '#96a0ad';
};

const getIcon = props => {
	if (props.success) return approveIcon;
	if (props.error) return errorIcon;
	return '';
};

const StyledInput = styled.textarea`
	outline: 0;
	padding: 10px;
	border-radius: 4px;
	border-style: solid;
	border-width: ${props => (props.noBorder ? '0' : '1px')};
	border-color: ${props => getBorderColor(props)};
	display: ${props => (props.inlineBlock ? 'inline-block' : 'block')};
	width: ${props => getWidth(props)};
	max-width: 100%;
	position: relative;
	padding-right: ${props => (props.hasIcon ? '45px' : '5px')};

	&:focus {
		border-color: ${props => getBorderColor(props, 'focus')};
	}

	&:disabled {
		background: ${colors.grey.lightest};
		cursor: disabled;
	}
`;

const InputContainer = styled.div`
	position: relative;
`;

const Icon = styled.span`
	display: ${props => (props.hasIcon ? 'block' : 'none')};
	position: absolute;
	right: 15px;
	width: 20px;
	height: 20px;
	top: 50%;
	transform: translateY(-50%);
	background: url(${props => getIcon(props)});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
`;

const Input = props => {
	const { className, input, ...rest } = props;

	const meta = props.meta || {};
	const valid = meta.valid || false;
	const invalid = meta.invalid || false;
	const submitFailed = meta.submitFailed || false;
	const error = meta.error || false;

	const hasIcon = (valid || invalid) && submitFailed;
	const hasError = meta.invalid && meta.submitFailed;

	return (
		<div className={className}>
			<InputContainer>
				<StyledInput {...rest} {...input} hasIcon={hasIcon} error={hasError} />
				<Icon {...rest} hasIcon={hasIcon} error={hasError} />
			</InputContainer>

			{submitFailed && error && <InputMessage>{error}</InputMessage>}
		</div>
	);
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Common/Textarea/Textarea.js